import { render, staticRenderFns } from "./DepartmentsInvoice.vue?vue&type=template&id=b79def14"
import script from "./DepartmentsInvoice.vue?vue&type=script&lang=js"
export * from "./DepartmentsInvoice.vue?vue&type=script&lang=js"
import style0 from "./DepartmentsInvoice.vue?vue&type=style&index=0&id=b79def14&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports